export default __webpack_public_path__ + "images/afeaeeb6b4a6006ba50c1d41d77130b9.svg";